import { render } from "./BuyInOffer.vue?vue&type=template&id=9020cfbe&scoped=true"
import script from "./BuyInOffer.vue?vue&type=script&lang=js"
export * from "./BuyInOffer.vue?vue&type=script&lang=js"

import "./BuyInOffer.vue?vue&type=style&index=0&id=9020cfbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9020cfbe"]])

export default __exports__